import { Component, OnInit, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { EventService } from 'src/app/services/event.service';

@Component({
  selector: 'app-reservation-for-house-hold',
  templateUrl: './reservation-for-house-hold.component.html',
  styleUrls: ['./reservation-for-house-hold.component.scss']
})
export class ReservationForHouseHoldComponent implements OnInit {
  /**
   * The Sortheader of the Table
   */
  @ViewChild(MatSort) sort: MatSort;
  /**
   * is the page finished Loading
   */
  finishedLoadingUsers: boolean = false;
  /**
   * The currentUser set via URL
   */
  currentUser: BusinessUserResource;
  /**
   * The stats of the Household
   */
  stats;
  /**
   * The IDS of all users to the Household
   */
  houseHoldIDs = [];
  /**
   * The Columns of the Table
   */
  displayedColumns = ['number', 'voucherKey', 'event.title', 'event.partner.name', 'created', 'menu'];
  /**
   * the Current page of Reservations
   */
  page = null;
  /**
   * The Data to be displayed
   */
  dataSource: MatTableDataSource<any>;
  /**
   * Page Metadata
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
/**
 * constructor
 * @param route 
 * @param businessuserService 
 * @param eventService 
 * @param router 
 */
  constructor(
    private route: ActivatedRoute,
    private businessuserService: BusinessuserService,
    private eventService: EventService,
    private router: Router) { }
  /**
   * ngOnInit
   * getBuissnessUser
   * getStatsForHouseHold
   * getCustomerGroupWithID
   */
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      combineLatest([
        this.businessuserService.getBuissnessUser(params['id']),
        this.businessuserService.getStatsForHouseHold(params['id']),
        this.businessuserService.getCustomerGroupWithID(params['id'])
      ]).pipe(
        map(([user, stats, group]: any) => {
          this.stats = stats;
          this.currentUser = user;
          group.forEach(element => {
            this.houseHoldIDs.push(element.publicId)
          });
          this.eventService.searchForEventReservations(0, 12, "created,desc", ["USED"], null, null, null, null, null, this.houseHoldIDs).subscribe((reservations: PagedResources<any>) => {
            this.page = reservations.page;
            this.dataSource = new MatTableDataSource(reservations.content);
            this.dataSource
          })
        })).subscribe(val => {
          this.finishedLoadingUsers = true;
        })
    })
  }
  /**
   * Load the Page of Reservations
   * @param event 
   */
  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }
  /**
   * search for the Reservationspage passed in
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.eventService.searchForEventReservations(pageIndex, pageSize, "created,desc", ["USED"], null, null, null, null, null, this.houseHoldIDs).subscribe((push: any) => {
      this.page = push.page
      this.pageData.pageIndex = pageIndex;
      this.pageData.pageSize = pageSize;
      this.dataSource = new MatTableDataSource(push.content);
    })
  }
  /**
   * Check if the Reservation can be used
   * @param reservation 
   * @returns 
   */
  canUse(reservation) {
    return reservation.state === 'RESERVED';
  };
  /**
   *  Check if the Reservation can be reverted
   * @param reservation 
   * @returns 
   */
  canCancelReservationUsage(reservation) {
    return reservation.state === 'USED';
  };
  /**
   * Check if the Reservation can be printed
   * @param reservation 
   * @returns 
   */
  canPrint(reservation) {
    return reservation.state !== 'CANCELLED';
  };
  /**
   *  Check if the Reservation can be canceled
   * @param reservation 
   * @returns 
   */
  canCancel(reservation) {
    return reservation.state === 'RESERVED' && (
      reservation.paymentState === 'NO_PAYMENT' ||
      reservation.paymentState === 'INVOICED' ||
      reservation.paymentState === 'PENDING'
    );
  }
  /**
   * Get the PDF to the Reservation
   * @param resID 
   */
  getPDF(resID) {
    this.eventService.getPDF(resID).subscribe(blob => {
      var file = new Blob([blob], { type: 'application/pdf' });
      let pdf = URL.createObjectURL(file);
      window.open(pdf)
    })
  }
  /**
   * Look for change on the sort Headers
   */
  ngAfterViewInit() {
    this.sort.sortChange.subscribe(value => {
      this.eventService.searchForEventReservations(this.pageData.pageIndex, this.pageData.pageSize, value.active + "," + value.direction, ["USED"], null, null, null, null, null, this.houseHoldIDs).subscribe((push: any) => {
        this.page = push.page
        this.dataSource = new MatTableDataSource(push.content);
      })
    })
  }
}
